<template>
  <router-btn v-if="CheckListLicense" :text="$t('servicesystem.common_objects.checklist.checklists')" :icon="'$checklist'"
    :color="color" :loading="loading" outlined :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "CheckListBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
      data: null,
    };
  },

  created() {
    this.getCurrent();
  },

  methods: {
    getCurrent() {
      if (this.CheckListLicense) {
        this.loading = true;
        this.getCheckListForJob(this.jobId)
          .then((data) => {
            this.data = data;
            //console.log('getCheckListForJob', data);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    action() {
      this.$router.push({ name: "ViewJobCheckList", params: { jobId: this.jobId } });
    },
  },

  computed: {
    color() {
      if (this.data && this.data[0] && this.data.some(x => !x.CompletedTime)) {
        return 'warning'
      }
      else {
        return 'primary'
      }
    },

    jobId() {
      return this.$route.params.jobId;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped></style>
